import { Theme, makeStyles } from "@material-ui/core";

export const useStyle = makeStyles((theme: Theme) => ({
  titleSection: {
    fontFamily: "Inter",
    fontWeight: 600,
    color: "black",
    fontSize: theme.typography.pxToRem(22),
    lineHeight: "30px",
    margin: "20px 0 30px 0px",
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    color: "black",
    fontSize: theme.typography.pxToRem(16),
  },
  dates: {
    margin: "10px",
  },
  container: {
    margin: "0 0px 30px 0",
  },
  gridSlot: {
    maxWidth: "100%",
    borderRadius: "8px",
    marginTop: "10px",
  },
  skeleton: {
    borderRadius: "8px",
    overflow: "hidden",
  },
  error: {
    color: "#F15A28",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    margin: "10px auto",
  },
}));
